import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './nps-feedback-eform.component.scss';
import * as $ from 'jquery';
var NpsFeedbackEform = /** @class */ (function (_super) {
    tslib_1.__extends(NpsFeedbackEform, _super);
    function NpsFeedbackEform(element) {
        return _super.call(this, element) || this;
    }
    NpsFeedbackEform.prototype.init = function () {
        this.count = 1;
        this.dataChecks = true;
        this.map = new Map();
        this.errors = [];
        this.emptyerrors = [];
        this.nextButtons = [];
        this.totalSteps = 0;
        this.completedSteps = new Map();
        this.eventsBound = false;
        this.isSubmitting = false;
        this.navigationDirection = 'forward';
        this.feedbackData = {
            feedback: []
        };
        this.formNames = new Map();
        this.analyticsFormName = "";
        this.modals = Array.from(this.element.querySelectorAll('.js-nps-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-nps-modal-open'));
        this.closeModalButton = this.element.querySelector('.js-nps-modal-close');
        this.openButton = this.element.querySelector('.js-nps-modal-open');
        this.buttonContainer = this.element.querySelector('.nps-toggle');
        this.closeButtonAction = this.element.querySelector('.close-action');
        this.form = this.element.querySelector("form");
        this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        this.pollSurvey = document.querySelector(".poll-survey");
        // buttons
        this.closeButton = this.element.querySelector(".js-apply-now-modal-close");
        this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
        this.formContainer = this.element.querySelector(".form-container__fields");
        // Extract analytics form name from form attribute (source of truth)
        if (this.form) {
            this.analyticsFormName = this.form.getAttribute('data-frmcontainer') || "";
        }
        // Parse questions from HTML dynamically
        this.parseQuestionsFromHTML();
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showStep(1);
        // Bind all event listeners
        this.bindEvents();
    };
    NpsFeedbackEform.prototype.parseQuestionsFromHTML = function () {
        var _this = this;
        // Add null check for wizardStepsContainer
        if (!this.wizardStepsContainer) {
            this.totalSteps = 0;
            return;
        }
        var steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        this.totalSteps = steps.length;
        steps.forEach(function (step, index) {
            var stepNumber = index + 1;
            var heading = step.getAttribute("data-heading");
            var questionAnalytics = step.getAttribute("data-question-analytics");
            var ratingGroup = step.querySelector('.star-rating');
            var textarea = step.querySelector('textarea');
            var radioGroup = step.querySelectorAll('input[type="radio"]');
            if (ratingGroup) {
                // Rating question
                var inputs = Array.from(ratingGroup.querySelectorAll('input[type="radio"]'));
                var fieldName = inputs[0].getAttribute('name') || "q" + stepNumber;
                var scale = inputs.length.toString();
                if (_this.feedbackData) {
                    _this.feedbackData.feedback.push({
                        id: stepNumber,
                        question: heading,
                        type: 'rating',
                        scale: scale,
                        fieldName: fieldName
                    });
                    _this.formNames.set(stepNumber, questionAnalytics);
                    _this.formNames.set(stepNumber.toString(), questionAnalytics);
                }
            }
            else if (textarea) {
                // Text question
                var fieldName = textarea.getAttribute('name') || "q" + stepNumber;
                if (_this.feedbackData) {
                    _this.feedbackData.feedback.push({
                        id: stepNumber,
                        question: heading,
                        type: 'text',
                        fieldName: fieldName
                    });
                    _this.formNames.set(stepNumber, questionAnalytics);
                    _this.formNames.set(stepNumber.toString(), questionAnalytics);
                }
            }
            else if (radioGroup.length > 0) {
                // Choice question
                var fieldName = radioGroup[0].getAttribute('name') || "q" + stepNumber;
                var scale = radioGroup.length.toString();
                if (_this.feedbackData) {
                    _this.feedbackData.feedback.push({
                        id: stepNumber,
                        question: heading,
                        type: 'choice',
                        scale: scale,
                        fieldName: fieldName
                    });
                    _this.formNames.set(stepNumber, questionAnalytics);
                    _this.formNames.set(stepNumber.toString(), questionAnalytics);
                }
            }
            else {
                // Info question
                if (_this.feedbackData) {
                    _this.feedbackData.feedback.push({
                        id: stepNumber,
                        question: heading,
                        type: 'info',
                        fieldName: "info" + stepNumber
                    });
                    _this.formNames.set(stepNumber, questionAnalytics);
                    _this.formNames.set(stepNumber.toString(), questionAnalytics);
                }
            }
        });
    };
    NpsFeedbackEform.prototype.getFormName = function (stepId) {
        if (!this.formNames) {
            return "";
        }
        var idStr = stepId.toString();
        var idNum = parseFloat(idStr);
        var result = this.formNames.get(idNum) || this.formNames.get(idStr) || "";
        return result;
    };
    NpsFeedbackEform.prototype.getCurrentVisibleStepNumber = function () {
        if (!this.wizardStepsContainer) {
            return null;
        }
        var currentStep = this.wizardStepsContainer.querySelector('.form-container-wizard__steps--step:not(.form-container-wizard__steps--hidden)');
        if (!currentStep) {
            return null;
        }
        var stepAttr = currentStep.getAttribute('data-step');
        return stepAttr ? parseInt(stepAttr, 10) : null;
    };
    NpsFeedbackEform.prototype.bindEvents = function () {
        var _this = this;
        // Prevent duplicate event binding
        if (this.eventsBound) {
            return;
        }
        this.eventsBound = true;
        this.closeButtonAction.addEventListener('click', function () { return _this.closeCallMeBackModal(); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openCallMeBackModals(event);
            _this.globalApplicationStart();
        }); });
        // Handle star rating interactions dynamically
        document.querySelectorAll('.star-rating').forEach(function (ratingGroup) {
            var labels = Array.from(ratingGroup.querySelectorAll('.star-rating__label'));
            var inputs = Array.from(ratingGroup.querySelectorAll('.star-rating__input'));
            function setSelectedByIndex(index) {
                labels.forEach(function (label, i) {
                    if (i >= index)
                        label.classList.add('selected');
                    else
                        label.classList.remove('selected');
                });
            }
            inputs.forEach(function (input, idx) {
                input.addEventListener('change', function () {
                    if (input.checked)
                        setSelectedByIndex(idx);
                });
            });
            // Initialize checked
            var checkedInput = ratingGroup.querySelector('.star-rating__input:checked');
            if (checkedInput) {
                var idx = inputs.indexOf(checkedInput);
                if (idx !== -1)
                    setSelectedByIndex(idx);
            }
        });
        // Rating & Choice inputs - dynamically capture responses and handle selection classes
        var ratingInputs = this.form.querySelectorAll('input[type="radio"]');
        ratingInputs.forEach(function (input) {
            input.addEventListener('change', function (event) {
                var target = event.target;
                var fieldName = target.name;
                // Handle visual choice card selection state
                if (target.classList.contains('choice-card__input')) {
                    var choiceGroup = target.closest('.choice-cards-container');
                    if (choiceGroup) {
                        choiceGroup.querySelectorAll('.choice-card').forEach(function (card) {
                            card.classList.remove('selected');
                        });
                    }
                    var parentCard = target.closest('.choice-card');
                    if (parentCard) {
                        parentCard.classList.add('selected');
                    }
                }
                var feedbackItem = _this.feedbackData.feedback.find(function (item) { return item.fieldName === fieldName; });
                if (feedbackItem) {
                    feedbackItem.response = target.value;
                }
            });
        });
        // Text inputs - dynamically capture responses
        var textInputs = this.form.querySelectorAll('textarea');
        textInputs.forEach(function (textarea) {
            textarea.addEventListener('input', function (event) {
                var target = event.target;
                var fieldName = target.name;
                var feedbackItem = _this.feedbackData.feedback.find(function (item) { return item.fieldName === fieldName; });
                if (feedbackItem) {
                    feedbackItem.response = target.value;
                }
            });
        });
        // Next/Previous buttons - dynamically bind based on number of steps
        var nextButtons = Array.from(this.form.querySelectorAll('.js_next-step1-button, .js_next-step2-button, .js_next-step3-button, [data-step][class*="js_next"]'));
        var allNextButtons = Array.from(this.form.querySelectorAll('button[class*="js_next"]'));
        allNextButtons.forEach(function (button) {
            button.addEventListener('click', function (event) {
                _this.navigationDirection = 'forward';
                var visibleStepNumber = _this.getCurrentVisibleStepNumber();
                if (visibleStepNumber !== null) {
                    _this.handleNextStep(visibleStepNumber);
                }
                else {
                    var target = event.currentTarget;
                    var currentStep = target.closest('.form-container-wizard__steps--step');
                    if (currentStep) {
                        var stepNumber = parseInt(currentStep.getAttribute('data-step') || "", 10);
                        if (!Number.isNaN(stepNumber)) {
                            _this.handleNextStep(stepNumber);
                        }
                    }
                }
            });
        });
        // Bind all submit buttons (for multiple final steps)
        var allSubmitButtons = Array.from(this.element.querySelectorAll(".js_submit-button"));
        allSubmitButtons.forEach(function (button) {
            button.addEventListener("click", function () {
                _this.handleSubmit();
            });
        });
        // Back button
        if (this.backButton.length) {
            this.backButton.map(function (item) {
                return item.addEventListener("click", function (event) {
                    _this.navigationDirection = 'backward';
                    _this.showPreviousStep(event);
                });
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener("click", function () {
                _this.resetForm();
                _this.closeCallMeBackModal();
            });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener("click", function () { return _this.resetForm(); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    NpsFeedbackEform.prototype.handleNextStep = function (currentStep) {
        var nextStep = currentStep + 1;
        // Query within wizardStepsContainer instead of form
        var _form = this.wizardStepsContainer ? this.wizardStepsContainer.querySelector(".form-container-wizard__steps--step[data-step=\"" + currentStep + "\"]") : null;
        if (_form) {
            // Clear any existing error messages on this step first
            var existingErrors = _form.querySelectorAll('.form__group--error_message');
            existingErrors.forEach(function (error) { return error.remove(); });
            // Clear any existing error classes
            var existingErrorGroups = _form.querySelectorAll('.form__group--error');
            existingErrorGroups.forEach(function (group) {
                group.classList.remove('form__group--error');
            });
            // First, capture current responses from the form
            this.captureAllResponses();
            // Get the feedback item for this step
            var feedbackItem = this.feedbackData.feedback.find(function (item) { return item.id === currentStep; });
            var hasValidationError = false;
            var errorMessage = '';
            if (feedbackItem && feedbackItem.type === 'info') {
                // No validation needed for info step
                hasValidationError = false;
            }
            else {
                // Bulletproof DOM-level check for inputs inside this step
                var ratingGroup = _form.querySelector('.star-rating');
                var choiceGroup = _form.querySelector('.choice-group');
                var textarea = _form.querySelector('textarea');
                if (ratingGroup) {
                    var checkedRadio = ratingGroup.querySelector('input[type="radio"]:checked');
                    if (!checkedRadio) {
                        hasValidationError = true;
                        errorMessage = 'This field is required';
                    }
                    else if (feedbackItem) {
                        feedbackItem.response = checkedRadio.value;
                    }
                }
                else if (choiceGroup) {
                    var checkedRadio = choiceGroup.querySelector('input[type="radio"]:checked');
                    if (!checkedRadio) {
                        hasValidationError = true;
                        errorMessage = 'This field is required';
                    }
                    else if (feedbackItem) {
                        feedbackItem.response = checkedRadio.value;
                    }
                }
                else if (textarea) {
                    var value = textarea.value.trim();
                    if (!value) {
                        hasValidationError = true;
                        errorMessage = 'Please provide your feedback';
                    }
                    else if (feedbackItem) {
                        feedbackItem.response = value;
                    }
                }
                else if (feedbackItem) {
                    // Fallback to memory check if DOM doesn't have standard elements
                    if (!feedbackItem.response || feedbackItem.response.toString().trim() === '') {
                        hasValidationError = true;
                        errorMessage = (feedbackItem.type === 'rating' || feedbackItem.type === 'choice') ? 'This field is required' : 'Please provide your feedback';
                    }
                }
            }
            // If validation error, display it
            if (hasValidationError) {
                // Determine what type of field this is to show error on correct element
                var ratingGroup = _form.querySelector('.star-rating');
                var choiceGroup = _form.querySelector('.choice-group');
                var textarea = _form.querySelector('textarea');
                if (ratingGroup) {
                    var formGroup = ratingGroup.classList.contains('form__group') ? ratingGroup : ratingGroup.closest('.form__group');
                    if (formGroup) {
                        formGroup.classList.add('form__group--error');
                        var errorDiv = document.createElement('div');
                        errorDiv.className = 'form__group--error_message';
                        errorDiv.textContent = errorMessage;
                        formGroup.appendChild(errorDiv);
                    }
                    else {
                        ratingGroup.classList.add('form__group--error');
                        var errorDiv = document.createElement('div');
                        errorDiv.className = 'form__group--error_message';
                        errorDiv.textContent = errorMessage;
                        ratingGroup.appendChild(errorDiv);
                    }
                }
                else if (choiceGroup) {
                    choiceGroup.classList.add('form__group--error');
                    var errorDiv = document.createElement('div');
                    errorDiv.className = 'form__group--error_message';
                    errorDiv.textContent = errorMessage;
                    choiceGroup.appendChild(errorDiv);
                }
                else if (textarea) {
                    var formGroup = textarea.closest('.form__group');
                    if (formGroup) {
                        formGroup.classList.add('form__group--error');
                        var errorDiv = document.createElement('div');
                        errorDiv.className = 'form__group--error_message';
                        errorDiv.textContent = errorMessage;
                        formGroup.appendChild(errorDiv);
                    }
                }
            }
            // If no validation error from required fields, proceed
            if (!hasValidationError) {
                var isForwardNavigation = this.navigationDirection === 'forward';
                var stepWasAlreadyCompleted = this.completedSteps.get(currentStep) === true;
                var shouldTriggerCompletion = isForwardNavigation && !stepWasAlreadyCompleted;
                if (shouldTriggerCompletion) {
                    // Record completion of the current step before switching to the next one
                    var responseValue = feedbackItem ? feedbackItem.response : "";
                    this.analyticsFormComplete("step" + currentStep, responseValue);
                    if (feedbackItem) {
                        this.globalFormComplete();
                    }
                }
                this.count += 1;
                this.completedSteps.set(currentStep, true);
                this.showStep(nextStep);
            }
        }
    };
    NpsFeedbackEform.prototype.handleSubmit = function () {
        // Prevent duplicate submissions
        if (this.isSubmitting) {
            return;
        }
        this.isSubmitting = true;
        // Re-initialize wizardStepsContainer in case component state was lost
        if (!this.wizardStepsContainer) {
            this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        }
        // Re-populate feedback data if it was cleared
        if (this.feedbackData.feedback.length === 0) {
            this.parseQuestionsFromHTML();
        }
        // Capture all current form values before submission
        this.captureAllResponses();
        // Calculate total steps fresh instead of relying on instance state
        var allSteps = this.wizardStepsContainer ? Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step")) : [];
        var totalSteps = allSteps.length;
        if (totalSteps === 0) {
            this.isSubmitting = false;
            return;
        }
        // Query the step container directly (not buttons div)
        var _form = this.wizardStepsContainer ? this.wizardStepsContainer.querySelector(".form-container-wizard__steps--step[data-step=\"" + totalSteps + "\"]") : null;
        if (!_form) {
            this.isSubmitting = false;
            return;
        }
        if (_form) {
            // Clear any existing error messages on this step first
            var existingErrors = _form.querySelectorAll('.form__group--error_message');
            existingErrors.forEach(function (error) { return error.remove(); });
            // Clear any existing error classes
            var existingErrorGroups = _form.querySelectorAll('.form__group--error');
            existingErrorGroups.forEach(function (group) {
                group.classList.remove('form__group--error');
            });
            // First, capture current responses from the form
            this.captureAllResponses();
            // Get the feedback item for this step
            var feedbackItem = this.feedbackData.feedback.find(function (item) { return item.id === totalSteps; });
            var hasValidationError = false;
            var errorMessage = '';
            if (feedbackItem && feedbackItem.type === 'info') {
                hasValidationError = false;
            }
            else {
                // Bulletproof DOM-level check for inputs inside the final step
                var ratingGroup = _form.querySelector('.star-rating');
                var choiceGroup = _form.querySelector('.choice-group');
                var textarea = _form.querySelector('textarea');
                if (ratingGroup) {
                    var checkedRadio = ratingGroup.querySelector('input[type="radio"]:checked');
                    if (!checkedRadio) {
                        hasValidationError = true;
                        errorMessage = 'This field is required';
                    }
                    else if (feedbackItem) {
                        feedbackItem.response = checkedRadio.value;
                    }
                }
                else if (choiceGroup) {
                    var checkedRadio = choiceGroup.querySelector('input[type="radio"]:checked');
                    if (!checkedRadio) {
                        hasValidationError = true;
                        errorMessage = 'This field is required';
                    }
                    else if (feedbackItem) {
                        feedbackItem.response = checkedRadio.value;
                    }
                }
                else if (textarea) {
                    var value = textarea.value.trim();
                    if (!value) {
                        hasValidationError = true;
                        errorMessage = 'Please provide your feedback';
                    }
                    else if (feedbackItem) {
                        feedbackItem.response = value;
                    }
                }
                else if (feedbackItem) {
                    // Fallback to memory check if DOM doesn't have standard elements
                    if (!feedbackItem.response || feedbackItem.response.toString().trim() === '') {
                        hasValidationError = true;
                        errorMessage = (feedbackItem.type === 'rating' || feedbackItem.type === 'choice') ? 'This field is required' : 'Please provide your feedback';
                    }
                }
            }
            // If validation error, display it
            if (hasValidationError) {
                // Determine what type of field this is to show error on correct element
                var ratingGroup = _form.querySelector('.star-rating');
                var choiceGroup = _form.querySelector('.choice-group');
                var textarea = _form.querySelector('textarea');
                if (ratingGroup) {
                    var formGroup = ratingGroup.classList.contains('form__group') ? ratingGroup : ratingGroup.closest('.form__group');
                    if (formGroup) {
                        formGroup.classList.add('form__group--error');
                        var errorDiv = document.createElement('div');
                        errorDiv.className = 'form__group--error_message';
                        errorDiv.textContent = errorMessage;
                        formGroup.appendChild(errorDiv);
                    }
                    else {
                        ratingGroup.classList.add('form__group--error');
                        var errorDiv = document.createElement('div');
                        errorDiv.className = 'form__group--error_message';
                        errorDiv.textContent = errorMessage;
                        ratingGroup.appendChild(errorDiv);
                    }
                }
                else if (choiceGroup) {
                    choiceGroup.classList.add('form__group--error');
                    var errorDiv = document.createElement('div');
                    errorDiv.className = 'form__group--error_message';
                    errorDiv.textContent = errorMessage;
                    choiceGroup.appendChild(errorDiv);
                }
                else if (textarea) {
                    var formGroup = textarea.closest('.form__group');
                    if (formGroup) {
                        formGroup.classList.add('form__group--error');
                        var errorDiv = document.createElement('div');
                        errorDiv.className = 'form__group--error_message';
                        errorDiv.textContent = errorMessage;
                        formGroup.appendChild(errorDiv);
                    }
                }
                this.isSubmitting = false;
            }
            // If no validation error from required fields, proceed
            if (!hasValidationError) {
                var stepWasAlreadyCompleted = this.completedSteps.get(totalSteps) === true;
                if (feedbackItem && this.navigationDirection === 'forward' && !stepWasAlreadyCompleted) {
                    this.analyticsFormComplete("step" + totalSteps, feedbackItem.response);
                    this.globalFormComplete();
                }
                this.completedSteps.set(totalSteps, true);
                this.submitForm(this.form);
            }
        }
    };
    NpsFeedbackEform.prototype.captureAllResponses = function () {
        var _this = this;
        // Capture all radio button responses
        var ratingInputs = this.form.querySelectorAll('input[type="radio"]:checked');
        ratingInputs.forEach(function (input) {
            var fieldName = input.getAttribute('name');
            var feedbackItem = _this.feedbackData.feedback.find(function (item) { return item.fieldName === fieldName; });
            if (feedbackItem) {
                feedbackItem.response = input.value;
            }
        });
        // Capture all textarea responses
        var textInputs = this.form.querySelectorAll('textarea');
        textInputs.forEach(function (textarea) {
            var fieldName = textarea.getAttribute('name');
            var value = textarea.value.trim();
            var feedbackItem = _this.feedbackData.feedback.find(function (item) { return item.fieldName === fieldName; });
            if (feedbackItem) {
                feedbackItem.response = value;
            }
        });
    };
    NpsFeedbackEform.prototype.analyticsApplicationComplete = function () {
        if ((typeof dataLayer != 'undefined')) {
            // Use current total steps for application step, or derive from current step
            var currentStep = this.totalSteps > 0 ? "Step " + this.totalSteps : "Step 4";
            var applicationName = "application:business:give us feedback";
            if (!dataLayer.application) {
                dataLayer.application = {};
            }
            dataLayer.application.applicationStep = currentStep;
            dataLayer.application.applicationName = applicationName;
        }
        if ((typeof _satellite != 'undefined')) {
            _satellite.track("globalApplicationComplete");
        }
    };
    NpsFeedbackEform.prototype.analyticsFormStart = function (step) {
        if ((typeof dataLayer != 'undefined')) {
            var stepMatch = step.match(/\d+/);
            var stepNum = stepMatch ? parseInt(stepMatch[0]) : 1;
            var applicationName = "application:business:give us feedback";
            dataLayer.formisSubmitted = false;
            dataLayer.formName = this.getFormName(stepNum);
            dataLayer.formStatus = "";
            if (!dataLayer.application) {
                dataLayer.application = {};
            }
            dataLayer.application.applicationName = applicationName;
            dataLayer.application.applicationStep = "Step " + stepNum;
        }
    };
    NpsFeedbackEform.prototype.globalApplicationStart = function () {
        this.analyticsFormStart('step1');
        if (typeof _satellite != 'undefined') {
            _satellite.track("globalApplicationStart");
        }
        this.analyticsService.dtmFormStart();
    };
    NpsFeedbackEform.prototype.globalFormComplete = function () {
        if ((typeof _satellite != 'undefined')) {
            _satellite.track("globalFormComplete");
        }
    };
    NpsFeedbackEform.prototype.analyticsFormComplete = function (step, options) {
        if (options === void 0) { options = ""; }
        var stepMatch = step.match(/\d+/);
        var stepNum = stepMatch ? parseInt(stepMatch[0]) : 1;
        var formName = this.getFormName(stepNum);
        // Keep analyticsFormName aligned for event payloads, but preserve DOM form state for the next step.
        if (formName) {
            this.analyticsFormName = formName;
        }
        if ((typeof dataLayer != 'undefined')) {
            var surveyID = formName.split(':')[0] || "give us feedback";
            dataLayer.formisSubmitted = true;
            dataLayer.formName = formName;
            dataLayer.formStatus = "complete";
            if (stepNum !== this.totalSteps) {
                dataLayer.surveyID = surveyID;
                dataLayer.surveyRating = options;
            }
        }
    };
    NpsFeedbackEform.prototype.getCallMeBackModalById = function (id) {
        return document.querySelector("#" + id);
    };
    NpsFeedbackEform.prototype.showOpenButton = function () {
        var _this = this;
        this.closeModalButton.classList.remove('nps-toggle__toggle-icon--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.add('nps-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.openButton.classList.add('nps-toggle__toggle-text--visible');
        }, 300);
    };
    NpsFeedbackEform.prototype.showCloseButton = function () {
        var _this = this;
        this.openButton.classList.remove('nps-toggle__toggle-text--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.remove('nps-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.closeModalButton.classList.add('nps-toggle__toggle-icon--visible');
        }, 300);
    };
    NpsFeedbackEform.prototype.isClickOutsideCallMeBackModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeCallMeBackModal();
        }
    };
    NpsFeedbackEform.prototype.openCallMeBackModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-nps-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getCallMeBackModalById(modalId);
        this.openCallMeBackModal();
    };
    NpsFeedbackEform.prototype.closeCallMeBackModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        this.activeModal.querySelector('.nps__modal-dialog').classList.remove('nps__modal-dialog--open');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
        this.showOpenButton();
    };
    NpsFeedbackEform.prototype.openCallMeBackModal = function () {
        this.resetForm();
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
        this.activeModal.querySelector('.nps__modal-dialog').classList.add('nps__modal-dialog--open');
        this.showCloseButton();
    };
    NpsFeedbackEform.prototype.resetForm = function () {
        this.navigationDirection = 'forward';
        this.displaySuccess.classList.add("hidden");
        var firstStep = this.form.querySelector(".form-container-wizard__steps--step[data-step='1']");
        if (firstStep) {
            firstStep.classList.remove("form-container-wizard__steps--hidden");
        }
        this.formContainer.classList.remove("hidden");
        this.form.reset();
        this.count = 1;
        this.completedSteps.clear();
        // Only clear responses, NOT the feedback structure
        this.feedbackData.feedback.forEach(function (item) {
            item.response = undefined;
        });
        this.showStep(1);
        document.querySelectorAll('.star-rating').forEach(function (ratingGroup) {
            var labels = Array.from(ratingGroup.querySelectorAll('.star-rating__label'));
            labels.forEach(function (label) {
                label.classList.remove('selected');
            });
        });
        document.querySelectorAll('.choice-card').forEach(function (card) {
            card.classList.remove('selected');
        });
    };
    NpsFeedbackEform.prototype.showStep = function (stepId) {
        var _this = this;
        var showStep = parseFloat(stepId);
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        var _heading = "";
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute("data-step"));
            if (_step == showStep) {
                _heading = pStep.getAttribute("data-heading");
                pStep.classList.remove("form-container-wizard__steps--hidden");
                // Update progress bar based on current step
                var progressBar = pStep.querySelector('.progress-bar__fill');
                if (progressBar && _this.totalSteps > 0) {
                    var progressPercentage = (showStep / _this.totalSteps) * 100;
                    progressBar.style.width = progressPercentage + '%';
                }
                // Update form data attribute with the analytics string immediately
                var analyticsString = _this.getFormName(showStep);
                if (analyticsString) {
                    _this.form.setAttribute("data-frmcontainer", analyticsString);
                }
            }
            else {
                pStep.classList.add("form-container-wizard__steps--hidden");
            }
        });
        window.scrollTo(0, 0);
    };
    NpsFeedbackEform.prototype.showPreviousStep = function (event) {
        this.showDisplayView("");
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        var prevStep = parseFloat(_nextStep);
        this.showStep(prevStep);
    };
    NpsFeedbackEform.prototype.submitForm = function (form) {
        var _this = this;
        // Add submission timestamp
        this.feedbackData.submittedAt = new Date().toISOString();
        // Clean up payload - remove fieldName and keep only required fields
        var cleanedFeedback = this.feedbackData.feedback
            .filter(function (item) { return item.type !== 'info'; })
            .map(function (item) { return ({
            id: item.id,
            question: item.question,
            type: item.type,
            scale: item.scale,
            response: item.response
        }); });
        var _postData = {
            feedback: cleanedFeedback,
            submittedAt: this.feedbackData.submittedAt
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/nps-feedback";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config)
            .then(function (pResponse) {
            _this.isSubmitting = false;
            if (pResponse.data === "invalid") {
                _this.showDisplayView("error");
            }
            else {
                _this.showDisplayView("success");
                _this.analyticsApplicationComplete();
            }
        })
            .catch(function (pError) {
            // service failed
            _this.isSubmitting = false;
            _this.showDisplayView("error");
        });
    };
    NpsFeedbackEform.prototype.showDisplayView = function (pDisplay) {
        window.scroll({ top: 50, behavior: "smooth" });
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    return NpsFeedbackEform;
}(Base));
export { NpsFeedbackEform };



//////////////////
// WEBPACK FOOTER
// ./components/nps-feedback-eform/nps-feedback-eform.component.ts
// module id = 1115
// module chunks = 0